export default __webpack_public_path__ + "static/media/project-tata-tiscon.038e8ad6.png";